import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { userService } from '../../_services';
import errorImage from '../../images/404.png';

const ErrorPage = () => {
    const isLoggedIn = !userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"));
    
    const getHomeRoute = () => {
        if (!isLoggedIn) return "/";
        
        const userType = window.atob(localStorage.getItem('_Host_Pro_type'));
        if (userType === "Admin") return "/Admin/groups";
        if (userType === "consumer") return "/consumer/Summary";
        return "/summary";
    };

    return (
        <div className="min-h-screen bg-secondary flex items-center justify-center p-4">
            <Card className="w-full max-w-xl shadow-lg">
                <CardContent className="p-4 sm:p-8 md:p-12 text-center">
                    {/* Error Image */}
                    <div className="mb-6 flex justify-center">
                        <img 
                            src={errorImage} 
                            alt="404 Error" 
                            className="w-50 h-auto object-contain"
                        />
                    </div>

                    {/* Error Title */}
                    <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">404 Error
                    </h1>

                    {/* Error Description */}
                    <p className="text-lg text-foreground opacity-70 mb-8">
                        We can't find the page you're looking for.
                    </p>

                    {/* Home Button */}
                    <Link to={getHomeRoute()}>
                        <Button 
                            variant="secondary"
                            size="lg"
                        >
                            <Home className="mr-2 h-5 w-5" />
                            Take me Home
                        </Button>
                    </Link>
                </CardContent>
            </Card>
        </div>
    );
};

export default ErrorPage;
